export default "__VITE_ASSET__1EiKCyGr__"